import { ProjectCredentialsListDTO } from '../../domain/credentials/ProjectCredentialsDTO';
import { ProjectCredentialsList } from '../../domain/credentials/ProjectCredentialsList';
import { ProjectCredentialsMapper } from './ProjectCredentialsMapper';

export class ProjectCredentialsListMapper {
  static toDomain(props: ProjectCredentialsListDTO): ProjectCredentialsList {
    const { projects } = props;

    return ProjectCredentialsList.create({
      projects: projects.map(ProjectCredentialsMapper.toDomain),
    });
  }
}
